
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import PerPageDropdown from '@/components/PerPageDropdown.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import _ from 'lodash';
import CreateAccount from './Create.vue';
import CreateCustomer from '@/modules/Customers/Create.vue';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import EmptyNevronHeader from '@/components/ListNevronComponents/EmptyNevronHeader.vue';

@Component({
  components: {
    vPagination,
    ListNevronHeader,
    EmptyNevronHeader,
    Skeleton,
    NevronEmpty,
    NevronSearch,
    NevronSearchNoResults,
    CreateAccount,
    CreateCustomer,
    PerPageDropdown,
  },
})

export default class AccountsList extends Vue {
  response: any = null;
  items: IAccount[] = [];

  perpage = 20;

  indexList: number[] = [];
  allChecked = false;

  search: any = {
    query: '',
    current: '',
  };

  file: any = '';
  uploadResponse: any = '';
  exportData: any = '';

  message: any = {
    import: '',
    export: '',
    message: '',
  };

  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage);
  }, 400); // fetches data with debounce (ms)

  selectedAccount: any = null;

  /*
  * Watches if the curent page changed
  */
  ChangedPage() {
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current, this.perpage);
  }

  // select account to attach to customer
  selectAccount(id: any) {
    this.selectedAccount = Number(id);
  }

  perPageChange() {
    this.fetchData(1, this.search.query, this.perpage);
  }

  @Watch('uploadResponse')
  importCsv() {
    stores.accounts.importAccounts(this.uploadResponse, 'accounts')
      .then((response) => {
        this.message.import = response.result;
        this.message.message = response.message;
        if (response.result === true) {
          this.refresh();
          console.log(response.message);
        } else {
          console.log(response.message);
        }
      });
  }

  exportCSV() {
    stores.accounts.exportAccounts('accounts')
      .then((response) => {
        this.exportData = response.data;
        if (response.result === true) {
          const csv = this.exportData;
          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = 'NevronAccounts.csv';
          anchor.click();
        }
        this.message.message = response.message;
        this.message.export = response.result;
      });
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }
    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    // set perpage from URL
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }

    // promise prevents double fetching on first load
    this.fetchData(index, this.search.current, this.perpage)
      .then((response) => this.$watch('response.currentPage', this.ChangedPage));
  }

  refresh() {
    this.fetchData(this.response.currentPage, null, this.perpage);
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null, perpage: number = 20) {
    return stores.accounts.fetchData(index, search, perpage)
      .then((response: any) => {
        this.response = response;
        this.items = this.response.data;
        this.search.current = this.search.query;
        this.updateCheck();

      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  importFile(event: any) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadResponse = e.target ? e.target.result : '';
    };
    reader.readAsText(file);
  }

  deleteChecked() {
    console.log('Deleting multiple items not yet implemented');
  }

  deactivateChecked() {
    console.log('Deactivating multiple items not yet implemented');
  }

  openItem(itemId: string | number) {
    this.$router.push({
      name: 'accounts.show',
      params: {id: String(itemId)},
      query: {lastpage: String(this.response.currentPage), perpage: String(this.perpage)},
    });
  }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }

  /* when item is checked */
  updateCheck() {
    if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  get itemIds(): number[] {
    return this.items.map((item: any) => item.id);
  }

}
